export default __webpack_public_path__ + "30b28c801bcb68de226ae2d1c10d04ab.ogg";